<script lang="ts">
  import { goto } from '$app/navigation';

  import Button from '$shared/atoms/Button/Button.svelte';
  import Title from '$shared/atoms/Title/Title.svelte';
  import Nav from './Nav.svelte';

  interface Props {
    features?: any[];
    onfinish?: () => void;
    onevent?: (payload: any) => void;
  }

  let { features = [], onfinish, onevent }: Props = $props();

  let activeFeature: any | null = $state(null);
  let activeFeatureIndex = $state(0);

  $effect(() => {
    activeFeature = features[activeFeatureIndex] || null;
  });
  let hasMultipleFeatures = $derived(features.length > 1);

  const onClickNext = (): void => {
    activeFeatureIndex += 1;
  };

  const onClickPrev = (): void => {
    activeFeatureIndex -= 1;
  };

  const onClickNav = (index: number): void => {
    activeFeatureIndex = index;
  };

  const onClickCheckout = (): void => {
    onevent?.({ type: 'close' });
    activeFeature?.checkOutUrl && goto(activeFeature.checkOutUrl);
  };
</script>

<div class="comp-announcement">
  {#if activeFeature}
    <div class="picture">
      <div class="title">New Update</div>
      <div class="source" style="background-image: url({activeFeature?.image});">{''}</div>
    </div>
    <div class="context">
      <div class="title"><Title type="h2">{activeFeature.title || ''}</Title></div>
      <div class="desc">
        {activeFeature.summary || ''}
      </div>
      <div class="actions">
        {#if activeFeature.checkOutUrl}
          <div class="action">
            <Button onclick={onClickCheckout}>Check it out</Button>
          </div>
        {/if}
      </div>
    </div>
  {/if}
  {#if hasMultipleFeatures}
    <div class="nav">
      <Nav
        total={features.length}
        active={activeFeatureIndex}
        onclick={onClickNav}
        onnext={onClickNext}
        onprevious={onClickPrev}
        {onfinish}
      />
    </div>
  {/if}
</div>

<style>
  .comp-announcement {
    width: 514px;
    border-radius: 3px;
  }

  .picture {
    width: 100%;
    height: 370px;
    background-color: var(--green);
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .picture .title {
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
  }
  .picture .source {
    width: 389px;
    height: 279px;
    background-color: #fff;
    margin-top: 20px;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .context {
    padding: 24px;
  }
  .context .title {
    margin-bottom: 16px;
  }
  .context .desc {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: var(--grey-dark);
  }
  .context .actions {
    margin-top: 24px;
    display: grid;
    grid-gap: 16px;
  }
  .context .actions .action {
    grid-row: 1;
  }
</style>
